import { Button } from 'react-bootstrap';
import Input from '@/components/Input';
import Modal from '@/common/Modal';
import { create as createModal } from 'react-modal-promise';
import { onEnter } from '@/utils';
import useEventListener from '@/hooks/useEventListener';
import { useState } from 'react';

const prompt = (text: string, initialValue: string = '', heading?: string) => {
  return createModal(({ isOpen, onResolve, onReject }) => {
    const [value, setValue] = useState<string>(initialValue);

    useEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Escape') onReject();
      if (event.key === 'Enter') onResolve(value);
    });

    return (
      <Modal className="Popup-Prompt" show={isOpen} size="sm" centered header={() => <h4 className="w-100 text-uppercase">{heading}</h4>}>
        {text && <p>{text}</p>}
        <Input
          name="prompt-input"
          value={value}
          onChange={setValue}
          onKeyDown={onEnter(() => onResolve(value))}
          onFocus={(event) => {
            event.target.select();
          }}
          autoFocus
        />
        <div className="d-flex justify-content-end">
          <Button className="mt-2" variant="outline-primary" onClick={onReject}>
            Cancel
          </Button>
          <Button className="ms-2 mt-2" variant="primary" onClick={() => onResolve(value)} disabled={value.trim() === ''}>
            OK
          </Button>
        </div>
      </Modal>
    );
  })();
};

export default prompt;
